<template>
    <div ref="modalRef" class="relative w-full">
        <div  class="th-input th-input-lg flex items-center p-1"
              :class="{'border-eureka-500': mannedPopover}"
              @click="mannedPopover = !mannedPopover">

            <div v-if="chosenList.length" class="flex h-9 grow items-center gap-1 overflow-hidden">
                <span v-for="(item, index) in chosenList" :key="index"
                      class="flex h-6 shrink-0 items-center gap-1 rounded bg-grey-20 pl-2 pr-1 text-xs text-black">
                    <span>{{ item.label }}</span>
                    <div class="group h-4 w-4 hover:cursor-pointer hover:rounded-full hover:bg-gray-450">
                        <IconCloseSmall class="group-hover:fill-white" @click.stop="removeItem(item)" />
                    </div>
                </span>
            </div>

            <div v-else class="text-xs text-yellow-500">{{ $t('leastOne') }}</div>

        </div>
        <div
            class="th-menu absolute z-10 mt-1 w-full p-1" v-show="mannedPopover">
            <CheckboxGroup
                :allLabel="$t('selectAll')"
                :list-data="allLegals" v-model="checkedLegals"/>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watchEffect } from 'vue';
import { remove, includes } from 'lodash';
import IconCloseSmall from '@/components/icons/IconCloseSmall.vue'
import { onClickOutside } from '@vueuse/core'
import type { ISelectData, TLegalType } from '@/types';
import { CheckboxGroup } from '@eureka/shared/checkbox-group'
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const allLegals: ISelectData[] = [{
    id: 0,
    label: t('legal.0'),
    checked: true,
},
{
    id: 2,
    label: t('legal.2'),
    checked: true,
},
{
    id: 1,
    label: t('legal.1'),
    checked: true,
},
{
    id: 999,
    label: t('legal.999'),
    checked: true,
},
{
    id: 220,
    label: t('legal.220'),
    checked: true,
},
{
    id: 221,
    label: t('legal.221'),
    checked: true,
}
]
const mannedPopover = ref(false)

const checkedLegals = ref<TLegalType[]>([])
const modalRef = ref(null)
const chosenList = computed(() => {
    return allLegals.filter((a) => includes(checkedLegals.value, a.id))
})
const emits = defineEmits<{
    (e: 'handleChange', value: TLegalType[]): void
}>()

watchEffect(() => {
    emits('handleChange', checkedLegals.value)
})

onClickOutside(
    modalRef,
    () => {
        mannedPopover.value = false
    }
)

function removeItem(item: ISelectData) {
    remove(checkedLegals.value, (l) => l === item.id)
}

onMounted(() => {
    checkedLegals.value = allLegals.map(a => a.id) as TLegalType[]
})

</script>
